// extracted by mini-css-extract-plugin
export default {"caretFlash":"caret-flash-module__caretFlash--Y2C9R","flashAnimation":"caret-flash-module__flashAnimation--auit_"};